

















































































































































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
// import {
//     componentDataType,
//     SmoothScrollType
// } from "../types";
import {
    ADD_ANIMATION
} from "../store/mutations.names";
import {
    HOST,
    API_URL
} from "../global";
import axios from "axios";

const DEFAULT_LANDSOWNER_FORM = {
    location: "",
    address: "",
    size_of_theLand: null,
    road_width: null,
    land_category: null,
    facing: null,
    attractive_features: null,
    land_owner_name: "",
    contact_person: "",
    email: "",
    contact_number: ""
};

@Component({
    name: "Landownercomp",
})
export default class Landownercomp extends Vue {
    @Prop() public compData!: string | null;
    @Prop() public last!: boolean;
    @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
    @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
    @Mutation(ADD_ANIMATION) public[ADD_ANIMATION]: any;
    public addedAnimation: boolean = false;
    public isDropps: boolean = false;
    public HOST: string = HOST;
    scroll: any | null = null;

    public landCategory: any | null = null;
    public facing: any | null = null;
    public feature: any | null = null;

    public landsForm: any = JSON.parse(JSON.stringify(DEFAULT_LANDSOWNER_FORM));
    submitted: boolean = false;
    submitSuccess: boolean = false;

    // openselection (){
    //    this.isDropps = !this.isDropps;
    // }

    resetForm() {
        this.landsForm = JSON.parse(JSON.stringify(DEFAULT_LANDSOWNER_FORM));
    }
    submitForm() {
        this.$validator.validate().then(valid => {
            if (valid) {
                axios
                    .post(`${API_URL}/landowner-form/`, this.landsForm)
                    .then((resp: any) => {
                        this.submitted = true;
                        this.submitSuccess = true;
                    })
                    .catch((err: any) => {
                        this.submitted = true;
                    });
            }
        });
    }

    public mounted() {
        axios
            .get(`${API_URL}/land-categories/${(this.landCategory = true)}`)
            .then((resp: any) => {
                this.landCategory = resp.data;
            });

        axios
            .get(`${API_URL}/facing-list/${(this.facing = true)}`)
            .then((resp: any) => {
                this.facing = resp.data;
            });

        axios
            .get(`${API_URL}/attractive-feature-list/${(this.feature = true)}`)
            .then((resp: any) => {
                this.feature = resp.data;
            });
    }
}
